export const sortArrayByDate = (a: Object, b: Object, index: string) => {
  let first = null;
  let second = null;
  if (a[index] !== null && typeof a[index] === 'object') {
    first = new Date(a[index].date);
    second = new Date(b[index].date);
  } else {
    first = new Date(a[index]);
    second = new Date(b[index]);
  }
  if (first >= second) {
    return 1;
  }
  return -1;
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/sortArrayByDate.ts